import React from 'react'
import cx from 'classnames'
import { Svgs } from '../../constants/images'

export interface IAccordion extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  open?: boolean
  setIsOpen: (isOpen: boolean) => void
}

const Accordion = function ({
  className,
  title,
  children,
  setIsOpen,
  open = false,
  ...props
}: IAccordion) {
  return (
    <div className={cx(className, 'ocla-accordion')} {...props}>
      <div className='ocla-accordion__title' onClick={() => setIsOpen(!open)}>
        {title}
        <img
          className={cx('ocla-accordion__title__icon', {
            'ocla-accordion__title__icon-active': open,
          })}
          src={Svgs.arrowDown}
        />
      </div>
      <div
        className={cx('ocla-accordion__children', {
          'ocla-accordion__children-active': open,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default React.memo(Accordion)
